var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckListdf5A571F(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M403.236 185.442c-.143 18.579-2.586 37.517-10.206 54.105a88.969 88.969 0 01-20.141 27.812c-19.847 18.772-47.394 28.936-74.031 32.123-37.66 4.505-75.757-1.891-113.632.093-23.636 1.247-47.107 5.73-70.772 6.353-23.664.623-48.253-3.015-68.343-16.659a88.96 88.96 0 01-20.055-18.988 108.867 108.867 0 01-16.946-31.4c-15.099-43.562-2.63-96.757 29.81-127.04C51.718 99.88 66.968 91.493 82.115 83.385c31.694-16.896 84.911-134.654 209.601-57.3 24.352 15.149 36.965 46.17 58.496 65.802 19.173 17.476 40.918 34.573 49.026 60.364 3.352 10.608 4.076 21.996 3.997 33.191z",
    fill: "rgb(56 120 244 )",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M372.888 267.359c-19.847 18.772-47.394 28.936-74.031 32.123-37.66 4.505-75.757-1.891-113.632.093-23.636 1.247-47.107 5.73-70.772 6.353-23.664.623-48.253-3.015-68.344-16.659a88.959 88.959 0 01-20.054-18.988 49.629 49.629 0 015.858-1.124c39.723-5.372 79.926-6.017 120.007-6.64l109.42-1.726c12.126-.194 24.309-.387 36.392.788 15.457 1.489 30.634 5.178 46.098 6.568 9.805.895 19.396-.538 29.058-.788z",
    fill: "rgb(56 120 244 )"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.966 269.679a2045.722 2045.722 0 00-222.092-.2c-12.498.666-25.219 1.497-36.893 6.016 5.73 5.236 14.253 5.651 22.017 5.78 56.893.917 113.791 1.17 170.694.76 3.338 0 7.951-1.483 7.292-4.763-.201-.989-.924-1.877-.867-2.865.108-1.827 2.443-2.486 4.298-2.572a70.612 70.612 0 0114.769.788c1.769.294 3.66.716 4.827 2.077.917 1.06 1.225 2.5 1.891 3.725 2.192 4.004 7.664 4.877 12.176 3.996 4.512-.881 8.709-3.008 13.272-3.237 4.018-.208 7.943 1.089 11.868 1.998 12.828 2.965 26.2 1.87 39.315.759 13.608-1.153 13.895-10.557.329-11.309-14.239-.766-28.628-.158-42.896-.953z",
    fill: "url(#prefix__paint0_linear_15777_44941)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.63 172.163l-6.138-33.52h8.43s1.934 26.816 2.865 34.086l-5.157-.566z",
    fill: "#BE6F46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.361 170.322s1.181 5.229.487 8.144c-.695 2.915-3.582 6.31-5.215 6.511-1.633.2-2.635-.602-2.514-1.712.122-1.11 4.298-5.057 3.653-6.31-.644-1.254-2.292 2.557-2.865 1.633-.573-.924-.329-2.357 1.11-4.169 1.44-1.812 0-4.34 0-4.34s4.326-1.92 5.344.243z",
    fill: "#BE6F46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.906 69.153c1.754-1.296 5.321-.852 7.09-.143a9.007 9.007 0 015.279 5.945 10.72 10.72 0 01.272 3.817c-.257 2.815-1.468 5.659-3.753 7.335-4.784 3.495-7.735.25-9.153-4.112a16.19 16.19 0 01-.845-7.72c.257-1.97-.645-3.525.88-4.936l.23-.186z",
    fill: "#606161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M342.906 69.153c1.754-1.296 5.321-.852 7.09-.143a9.007 9.007 0 015.279 5.945 10.72 10.72 0 01.272 3.817c-.257 2.815-1.468 5.659-3.753 7.335-4.784 3.495-7.735.25-9.153-4.112a16.19 16.19 0 01-.845-7.72c.257-1.97-.645-3.525.88-4.936l.23-.186z",
    fill: "url(#prefix__paint1_linear_15777_44941)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.878 93.728c7.326 0 13.265-7.408 13.265-16.546 0-9.137-5.939-16.545-13.265-16.545-7.326 0-13.265 7.408-13.265 16.545 0 9.138 5.939 16.546 13.265 16.546z",
    fill: "#606161"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.787 122.828s-2.435-4.297-3.488-4.935c-1.053-.637-2.922-2.406-3.466-2.005-.982.716 3.244 4.469-.523 4.19-.595-.05-3.617 0-5.078 1.368a2.793 2.793 0 00-.871 2.122 2.794 2.794 0 001.007 2.061c.988.673 4.383.988 6.217.931 1.833-.057 3.982.208 5.228.96",
    fill: "#BE6F46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M316.777 104.593s-1.741 5.472-1.912 8.43c-.172 2.958-1.562 15.385-2.027 15.994-.466.608-22.755-6.969-22.755-6.969s-1.347 1.898-.273 5.472c0 0 16.553 14.976 26.573 15.564 10.02.587 8.731-23.142 8.731-23.142M336.381 260.755l-1.841 4.161c1.088-.372 6.303 3.818 8.652 3.825a7.462 7.462 0 004.254-1.554l-1.475-7.542-2.629-37.338-14.131 2.049 7.17 36.399zM309.144 260.447l-2.714 2.543c1.146-.086 5.149 5.271 7.427 5.866a7.484 7.484 0 004.512-.444l.445-7.679 2.864-34.558-13.93 1.368 1.396 32.904zM338.065 88.22l.566 12.018a6.253 6.253 0 01-5.73 2.686c-5.801-.645-5.551-2.364-5.551-2.364s0-8.673-.229-10.614",
    fill: "#BE6F46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.684 92.13l1.339-2.42-10.894 1.21c.086.716.143 2.464.172 4.297a8.666 8.666 0 009.383-3.087z",
    fill: "#8A4621"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.646 175.214s1.748 33.062 4.076 59.821c0 0-31.974 4.605-45.031-.516 0 0 2.808-53.317 3.395-60.967l37.56 1.662z",
    fill: "#606161"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.646 175.214s1.748 33.062 4.076 59.821c0 0-31.974 4.605-45.031-.516 0 0 2.808-53.317 3.395-60.967l37.56 1.662z",
    fill: "url(#prefix__paint2_linear_15777_44941)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.655 103.898s-.057-2.364-8.244-2.435c-5.966-.057-8.051-.545-12.291.265-7.735 1.475-8.595 1.955-9.776 2.958-2.801 2.414-7.55 67.327-7.55 67.327s-4.748 7.792 19.84 10.299c9.097.931 17.906-5.372 17.906-5.372l.115-73.042z",
    fill: "rgb(56 120 244 )"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M342.591 68.76s-.48 15.391-4.956 20.656c-4.72 5.558-7.406 6.238-13.136 3.968-4.871-1.941-5.451-15.27-5.615-19.11-.423-9.963 14.847-18.543 23.707-5.515z",
    fill: "#BE6F46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346.151 114.441l.358 62.471-5.651 3.259-1.01-55.18 6.303-10.55z",
    fill: "url(#prefix__paint3_linear_15777_44941)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M341.394 98.791l.108 2.815a1.18 1.18 0 01-.645 1.089s-4.412 1.497-12.054 1.898l-5.616-1.433a1.165 1.165 0 01-.716-1.01l-.079-1.396a1.186 1.186 0 011.039-1.24l16.624-1.883a1.186 1.186 0 011.23.675c.071.152.108.318.109.485z",
    fill: "rgb(56 120 244 )"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M341.394 98.791l.108 2.815a1.18 1.18 0 01-.645 1.089s-4.412 1.497-12.054 1.898l-5.616-1.433a1.165 1.165 0 01-.716-1.01l-.079-1.396a1.186 1.186 0 011.039-1.24l16.624-1.883a1.186 1.186 0 011.23.675c.071.152.108.318.109.485z",
    fill: "url(#prefix__paint4_linear_15777_44941)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M340.817 78.522s.243-2.321 2.528-1.318c2.285 1.002.136 5.013-.752 6.138-.888 1.124-2.593.766-2.593.766",
    fill: "#BE6F46"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M344.427 67.828l.91 3.639h-1.49l-1.253-5.551 1.833 1.912z",
    fill: "#4EAE93"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M346.346 103.253s3.367 3.166 9.562 18.028c2.529 6.074 4.641 17.383 4.641 17.383s-8.637 4.434-13.73 4.434c-2.278-13.215-7.75-18.336-8.767-24.431-1.017-6.095 5.215-16.588 8.294-15.414zM302.203 263.727a12.128 12.128 0 00-6.288 4.241 5.304 5.304 0 00-1.11 2.8 2.803 2.803 0 001.31 2.586c.604.268 1.26.395 1.92.372 6.12.258 12.25.15 18.357-.322a1.768 1.768 0 001.383-.552 1.78 1.78 0 00.171-1.045l-.171-3.839a1.985 1.985 0 00-.316-1.218c-.68-.831-2.005-.136-3.072-.193-2.149-.115-2.693-2.787-4.462-3.524-2.02-.846-5.702.078-7.722.694zM332.019 263.505a12.05 12.05 0 00-6.289 4.241 5.29 5.29 0 00-1.117 2.8 2.785 2.785 0 00.299 1.473 2.78 2.78 0 001.019 1.105 4.344 4.344 0 001.919.38c6.12.259 12.251.149 18.357-.329a1.314 1.314 0 001.223-.36 1.31 1.31 0 00.332-1.23l-.172-3.847a1.96 1.96 0 00-.315-1.21c-.681-.831-2.006-.136-3.08-.193-2.149-.115-2.686-2.787-4.455-3.532-2.056-.845-5.73.079-7.721.702z",
    fill: "rgb(56 120 244 )"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.203 263.727a12.128 12.128 0 00-6.288 4.241 5.304 5.304 0 00-1.11 2.8 2.803 2.803 0 001.31 2.586c.604.268 1.26.395 1.92.372 6.12.258 12.25.15 18.357-.322a1.768 1.768 0 001.383-.552 1.78 1.78 0 00.171-1.045l-.171-3.839a1.985 1.985 0 00-.316-1.218c-.68-.831-2.005-.136-3.072-.193-2.149-.115-2.693-2.787-4.462-3.524-2.02-.846-5.702.078-7.722.694z",
    fill: "url(#prefix__paint5_linear_15777_44941)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332.019 263.505a12.05 12.05 0 00-6.289 4.241 5.29 5.29 0 00-1.117 2.8 2.785 2.785 0 00.299 1.473 2.78 2.78 0 001.019 1.105 4.344 4.344 0 001.919.38c6.12.259 12.251.149 18.357-.329a1.314 1.314 0 001.223-.36 1.31 1.31 0 00.332-1.23l-.172-3.847a1.96 1.96 0 00-.315-1.21c-.681-.831-2.006-.136-3.08-.193-2.149-.115-2.686-2.787-4.455-3.532-2.056-.845-5.73.079-7.721.702z",
    fill: "url(#prefix__paint6_linear_15777_44941)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M319.208 65.178c-.236.423-.458.867-.68 1.34a8.452 8.452 0 00-.838 4.01c0 .573 1.11 3.31 1.003 3.531a19.793 19.793 0 016.367-7.363c1.017 2.3 3.488 3.532 5.73 4.613 2.242 1.082 4.727 2.407 5.601 4.77.609 1.619.38 3.581 1.432 4.95 2.6-.352 3.166-4.549 5.73-5.014.466-.086.953 0 1.433-.13a2.863 2.863 0 002.056-2.664c.401-5.422-6.174-10.457-10.565-12.269a16.474 16.474 0 00-12.849 0 9.028 9.028 0 00-4.42 4.226z",
    fill: "#606161"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M319.208 65.178c-.236.423-.458.867-.68 1.34a8.452 8.452 0 00-.838 4.01c0 .573 1.11 3.31 1.003 3.531a19.793 19.793 0 016.367-7.363c1.017 2.3 3.488 3.532 5.73 4.613 2.242 1.082 4.727 2.407 5.601 4.77.609 1.619.38 3.581 1.432 4.95 2.6-.352 3.166-4.549 5.73-5.014.466-.086.953 0 1.433-.13a2.863 2.863 0 002.056-2.664c.401-5.422-6.174-10.457-10.565-12.269a16.474 16.474 0 00-12.849 0 9.028 9.028 0 00-4.42 4.226z",
    fill: "url(#prefix__paint7_linear_15777_44941)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.716 39.608H74.036c-6.322 0-11.446 5.125-11.446 11.446v213.354c0 6.321 5.124 11.445 11.445 11.445h131.681c6.322 0 11.446-5.124 11.446-11.445V51.054c0-6.322-5.124-11.446-11.446-11.446z",
    fill: "rgb(56 120 244 )"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.107 39.608H78.426c-6.321 0-11.445 5.125-11.445 11.446v213.354c0 6.321 5.124 11.445 11.445 11.445h131.681c6.321 0 11.446-5.124 11.446-11.445V51.054c0-6.322-5.125-11.446-11.446-11.446z",
    fill: "rgb(56 120 244 )"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.107 39.608H78.426c-6.321 0-11.445 5.125-11.445 11.446v213.354c0 6.321 5.124 11.445 11.445 11.445h131.681c6.321 0 11.446-5.124 11.446-11.445V51.054c0-6.322-5.125-11.446-11.446-11.446z",
    fill: "url(#prefix__paint8_linear_15777_44941)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.793 175.508L82.84 51.082l116.998 2.471s-15.299 129.153-4.498 162.487c10.801 33.334 12.599 45.84 12.599 45.84l-126.446 3.581-2.7-89.953z",
    fill: "url(#prefix__paint9_linear_15777_44941)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M228.974 250.878l-127.906 1.354s-13.15-76.402-15.436-102.015c-2.241-24.674-2.757-99.135-2.757-99.135h122.141s.308 72.162 2.471 96.07c2.392 26.379 21.487 103.726 21.487 103.726z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M286.057 49.729l-8.702-19.754-.716-1.676a.25.25 0 00-.122-.122.391.391 0 00-.529-.032.386.386 0 00-.115.154l-9.426 21.43a3.58 3.58 0 00-.287 1.432v206.922h20.184V51.168a3.579 3.579 0 00-.287-1.44zm.122 208.233h-19.904v-4.391h19.904v4.391z",
    fill: "rgb(56 120 244 )"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M282.87 51.168v202.403h-12.369V51.14a5.404 5.404 0 01.165-1.433l5.78-21.43a.181.181 0 01.043-.122c.121-.193.336-.143.408.122l.458 1.676 5.322 19.754c.13.476.195.968.193 1.461z",
    fill: "url(#prefix__paint10_linear_15777_44941)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M270.504 257.962h12.369v14.912c0 1.962-.988 3.545-2.184 3.545h-8.029c-1.203 0-2.149-1.583-2.149-3.545l-.007-14.912z",
    fill: "url(#prefix__paint11_linear_15777_44941)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M286.344 51.168a23.02 23.02 0 01-20.184 0l5.945-12.992 4.505-9.849 3.882 9.132 5.852 13.71z",
    fill: "url(#prefix__paint12_linear_15777_44941)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M280.493 37.43a12.178 12.178 0 01-8.388.717l4.506-9.848 3.882 9.132z",
    fill: "rgb(56 120 244 )"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M280.492 37.43c-2.865 1.433-6.446 1.19-8.867.617l4.527-10.593 4.34 9.977z",
    fill: "url(#prefix__paint13_linear_15777_44941)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M157.094 76.28H96.8c-1.12 0-2.027.906-2.027 2.023 0 1.118.908 2.024 2.027 2.024h60.294a2.026 2.026 0 002.027-2.024 2.026 2.026 0 00-2.027-2.023zM157.094 83.256H96.8c-1.12 0-2.027.906-2.027 2.023 0 1.118.908 2.024 2.027 2.024h60.294a2.025 2.025 0 002.027-2.024 2.026 2.026 0 00-2.027-2.023zM157.094 90.232H96.8c-1.12 0-2.027.906-2.027 2.024 0 1.117.908 2.023 2.027 2.023h60.294a2.025 2.025 0 002.027-2.023 2.026 2.026 0 00-2.027-2.024zM157.456 97.208H117.49c-.918 0-1.662.744-1.662 1.662v.724c0 .917.744 1.661 1.662 1.661h39.966c.918 0 1.662-.744 1.662-1.661v-.724c0-.918-.744-1.662-1.662-1.662zM157.766 120.493H97.472c-1.12 0-2.027.906-2.027 2.024 0 1.117.908 2.023 2.027 2.023h60.294a2.025 2.025 0 100-4.047zM157.766 127.47H97.472c-1.12 0-2.027.906-2.027 2.023s.908 2.023 2.027 2.023h60.294a2.025 2.025 0 002.026-2.023 2.025 2.025 0 00-2.026-2.023zM157.766 134.439H97.472c-1.12 0-2.027.905-2.027 2.023 0 1.117.908 2.023 2.027 2.023h60.294a2.024 2.024 0 100-4.046zM158.132 141.415h-39.966c-.918 0-1.662.744-1.662 1.661v.724c0 .918.744 1.662 1.662 1.662h39.966c.918 0 1.662-.744 1.662-1.662v-.724c0-.917-.744-1.661-1.662-1.661zM162.356 166.727h-60.3a2.396 2.396 0 01-2.292-2.027 1.725 1.725 0 011.754-2.02h60.294a2.383 2.383 0 012.299 2.02 1.738 1.738 0 01-1.009 1.88c-.235.104-.49.154-.746.147zM163.286 173.689h-60.3a2.39 2.39 0 01-2.314-2.056 1.744 1.744 0 01.401-1.424 1.734 1.734 0 011.354-.596h60.301a2.395 2.395 0 012.292 2.02 1.728 1.728 0 01-.987 1.901 1.744 1.744 0 01-.747.155zM164.219 180.651h-60.3a2.396 2.396 0 01-2.292-2.02 1.722 1.722 0 01.397-1.429 1.74 1.74 0 011.358-.598h60.321a2.396 2.396 0 012.292 2.027 1.722 1.722 0 01-.407 1.432 1.729 1.729 0 01-1.369.588zM165.516 187.612h-39.967a1.96 1.96 0 01-1.883-1.654l-.101-.716a1.438 1.438 0 01.826-1.536c.191-.086.398-.129.607-.126h39.973a1.96 1.96 0 011.884 1.662l.093.716a1.44 1.44 0 01-.332 1.16 1.429 1.429 0 01-1.1.494zM169.678 211.026h-60.3a2.576 2.576 0 01-2.414-2.048 1.647 1.647 0 011.64-2.049h60.3a2.577 2.577 0 012.414 2.049 1.638 1.638 0 01-1.64 2.048zM171.015 218.06H110.7a2.58 2.58 0 01-2.414-2.056 1.643 1.643 0 011.633-2.048h60.301a2.572 2.572 0 012.413 2.048c.065.246.071.502.019.751a1.643 1.643 0 01-1.637 1.305zM172.347 225.122h-60.301a2.582 2.582 0 01-2.413-2.048 1.654 1.654 0 01.325-1.412 1.645 1.645 0 011.315-.608h60.307a2.585 2.585 0 012.414 2.055 1.642 1.642 0 01-1.647 2.013zM174.048 232.184h-39.967a2.146 2.146 0 01-1.984-1.683l-.136-.716a1.344 1.344 0 01.74-1.556c.19-.087.398-.128.607-.12h39.966a2.152 2.152 0 011.977 1.676l.143.716a1.335 1.335 0 01-.252 1.178 1.349 1.349 0 01-1.094.505zM187.57 105.939h-12.019a8.697 8.697 0 01-8.688-8.688v-13a8.696 8.696 0 018.688-8.688h12.019a8.696 8.696 0 018.688 8.688V97.28a8.697 8.697 0 01-8.688 8.66zm-12.019-28.012a6.301 6.301 0 00-6.295 6.296V97.25a6.303 6.303 0 006.295 6.296h12.019a6.298 6.298 0 006.288-6.296v-13a6.296 6.296 0 00-6.288-6.295l-12.019-.029zM190.726 150.669h-11.983a8.679 8.679 0 01-8.681-8.294l-.573-12.764a8.685 8.685 0 018.681-9.082h11.997a8.677 8.677 0 018.631 8.301l.58 12.757a8.698 8.698 0 01-2.398 6.397 8.702 8.702 0 01-6.283 2.685h.029zm-12.577-27.74a6.282 6.282 0 00-5.895 4.08 6.278 6.278 0 00-.394 2.495l.58 12.763a6.274 6.274 0 006.282 6.002h12.004a6.29 6.29 0 006.289-6.575l-.581-12.756a6.289 6.289 0 00-6.288-6.009h-11.997zM182.54 192.039a8.675 8.675 0 01-8.652-7.993l-1.024-12.728a8.682 8.682 0 012.175-6.477 8.696 8.696 0 016.183-2.906l11.997-.415a8.758 8.758 0 018.968 7.964l1.024 12.728a8.718 8.718 0 01-2.178 6.475 8.707 8.707 0 01-6.181 2.908l-11.997.415-.315.029zm10.994-28.127h-.229l-11.997.415a6.315 6.315 0 00-4.476 2.108 6.299 6.299 0 00-1.576 4.69l1.024 12.727a6.317 6.317 0 006.489 5.787l11.997-.422a6.289 6.289 0 006.053-6.79l-1.025-12.728a6.273 6.273 0 00-6.26-5.787zM191.959 234.218a8.716 8.716 0 01-5.638-2.07 8.714 8.714 0 01-2.957-5.228l-2.005-12.406a8.684 8.684 0 014.725-9.183 8.695 8.695 0 013.547-.894l11.89-.416a8.78 8.78 0 018.881 7.299l2.006 12.405a8.695 8.695 0 01-8.273 10.078l-11.897.408-.279.007zm9.884-27.804h-.222l-11.889.415a6.294 6.294 0 00-5.974 7.299l2.013 12.405a6.38 6.38 0 002.239 3.843 6.382 6.382 0 004.207 1.443l11.89-.416a6.279 6.279 0 005.987-7.291l-2.005-12.412a6.305 6.305 0 00-6.246-5.286zM175.443 46.355h-58.302a4.262 4.262 0 00-4.262 4.262v6.66a4.262 4.262 0 004.262 4.262h58.302a4.261 4.261 0 004.261-4.261v-6.661a4.262 4.262 0 00-4.261-4.262z",
    fill: "rgb(56 120 244 )"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M175.443 46.355h-58.302a4.262 4.262 0 00-4.262 4.262v6.66a4.262 4.262 0 004.262 4.262h58.302a4.261 4.261 0 004.261-4.261v-6.661a4.262 4.262 0 00-4.261-4.262z",
    fill: "url(#prefix__paint14_linear_15777_44941)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.034 100.46l-10.5-10.478a3.6 3.6 0 01-1.054-2.543 3.59 3.59 0 011.054-2.543 3.597 3.597 0 015.085 0l5.014 5.014 16.824-19.46a3.598 3.598 0 015.444 4.705l-21.867 25.305zM186.98 144.108l-10.493-10.493a3.595 3.595 0 115.085-5.085l5.014 5.013 16.824-19.46a3.597 3.597 0 015.444 4.706l-21.874 25.319zM190.585 185.729l-10.501-10.515a3.596 3.596 0 015.086-5.085l5.013 5.014 16.825-19.461a3.585 3.585 0 012.457-1.234 3.602 3.602 0 012.61.866 3.596 3.596 0 011.234 2.457c.035.47-.024.943-.173 1.391a3.576 3.576 0 01-.692 1.219l-21.859 25.348zM199.911 227.579l-10.493-10.5a3.596 3.596 0 01.003-5.082 3.596 3.596 0 015.082.003l5.014 5.014 16.832-19.453a3.595 3.595 0 015.074-.369 3.6 3.6 0 01.369 5.075l-21.881 25.312zM286.182 253.571h-19.897v4.391h19.897v-4.391z",
    fill: "rgb(56 120 244 )"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M286.182 253.571h-19.897v4.391h19.897v-4.391z",
    fill: "url(#prefix__paint15_linear_15777_44941)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M286.344 258.083v14.791a3.538 3.538 0 01-3.581 3.545h-13.057a3.532 3.532 0 01-2.51-1.036 3.547 3.547 0 01-1.036-2.509v-14.791h20.184z",
    fill: "rgb(56 120 244 )"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M286.344 258.083v14.791a3.538 3.538 0 01-3.581 3.545h-13.057a3.532 3.532 0 01-2.51-1.036 3.547 3.547 0 01-1.036-2.509v-14.791h20.184z",
    fill: "url(#prefix__paint16_linear_15777_44941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_15777_44941",
    x1: 198.45,
    y1: 339.764,
    x2: 214.644,
    y2: -80.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_15777_44941",
    x1: 353.241,
    y1: 78.314,
    x2: 339.969,
    y2: 77.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_15777_44941",
    x1: 334.95,
    y1: 206.177,
    x2: 278.925,
    y2: 201.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_15777_44941",
    x1: 329.613,
    y1: 162.608,
    x2: 433.561,
    y2: 57.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_15777_44941",
    x1: 329.018,
    y1: 102.752,
    x2: 386.224,
    y2: 72.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_15777_44941",
    x1: 309.738,
    y1: 282.378,
    x2: 296.237,
    y2: 231.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_15777_44941",
    x1: 337.605,
    y1: 274.944,
    x2: 324.104,
    y2: 224.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_15777_44941",
    x1: 341.111,
    y1: 66.037,
    x2: 321.085,
    y2: 75.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_15777_44941",
    x1: 131.886,
    y1: -39.895,
    x2: 156.188,
    y2: 348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_15777_44941",
    x1: 50.473,
    y1: 261.135,
    x2: 384.37,
    y2: -106.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_15777_44941",
    x1: 370.13,
    y1: 104.571,
    x2: -239.886,
    y2: 349.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_15777_44941",
    x1: 295.544,
    y1: 259.244,
    x2: 177.127,
    y2: 306.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_15777_44941",
    x1: 276.99,
    y1: 37.861,
    x2: 275.192,
    y2: 70.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_15777_44941",
    x1: 274.383,
    y1: 41.986,
    x2: 285.628,
    y2: 13.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint14_linear_15777_44941",
    x1: 146.492,
    y1: 63.76,
    x2: 146.041,
    y2: 41.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint15_linear_15777_44941",
    x1: 276.033,
    y1: 250.233,
    x2: 277.387,
    y2: 287.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint16_linear_15777_44941",
    x1: 276.209,
    y1: 273.812,
    x2: 276.438,
    y2: 225.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckListdf5A571F);
export default __webpack_public_path__ + "static/media/checkList.df5a571f.6ffc198a9fabeaba1bbb364f8e483d03.svg";
export { ForwardRef as ReactComponent };